<template>
  <div class="hotLab">
    <div
      class="hotLab-top"
      :style="{
        background: `url(${$oss('trends/trends-bg.png')}) no-repeat`,
        backgroundSize: 'cover',
      }"
    >
      热门实验室
    </div>
    <div class="list" v-loading="listLoading">
      <div
        v-for="(item, index) in lists"
        :key="index"
        class="flex flex-row list-item"
      >
        <div class="list-num">
          {{ index + 1 }}
        </div>
        <div class="list-con flex-1">
          <div class="list-labName pointer" @click="toLabDetail(item)">
            {{ item.laboratoryName }}
          </div>
          <div class="flex flex-row flex-between list-other">
            <div>设备 {{ item.waresSum }}</div>
            <div>能力 {{ item.abilitySum }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { recommendLabList } from "@/api/lab";
export default {
  data() {
    return {
      lists: [],
      labTotal: 0,
      listLoading: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.listLoading = true;
      const res = await this.$axios
        .post(recommendLabList, this.page)
        .finally(() => {
          this.listLoading = false;
        });
      this.lists = res;
    },
    toLabDetail({ laboratoryId }) {
      this.$jump.push({ name: "labDetail", query: { id: laboratoryId } });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.hotLab {
  background: white;
  width: 100%;
  &-top {
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: white;
    font-size: 16px;
  }
}
.list {
  min-height: 300px;
  padding-top: 20px;
  padding-right: 10px;
  padding-bottom: 10px;
  &-item {
    margin-bottom: 10px;
    padding: 10px;
  }
  &-num {
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    color: white;
    text-align: center;
    // text-align: right;
    margin-right: 20px;
    font-size: 14px;
    font-weight: bolder;
    // padding-top: 5px;
    background: $theme-color;
    &.index1 {
      font-size: 16px;
      color: #fb0100;
    }
    &.index2,
    &.index3 {
      font-size: 16px;
      color: #fe6100;
    }
  }
  &-labName {
    font-size: 14px;
    color: #1c1c1c;
    margin-bottom: 8px;
  }
  &-other {
    font-size: 12px;
    color: #666666;
    padding-bottom: 8px;
    border-bottom: 1px dashed #d1d1d1;
  }
}
.list-item:last-child {
  margin-bottom: 0;
  .list-other {
    border-bottom: none;
  }
}
</style>
